
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getMaxlengthValidationRule, requiredValidationRule } from '@/helpers/validationRules';

@Component({})
export default class StreetAddressTextField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  get fieldValue() {
    return this.value;
  }

  set fieldValue(value) {
    this.$emit('input', value || '');
  }

  public maxlength = 30;
  public fieldValidationRules = [requiredValidationRule, getMaxlengthValidationRule(this.maxlength)];
}
